import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IModal } from "./BlackList";
import { format } from "date-fns";
import { IClientCompanyDropdown, IStatusDropdown } from "../../models/IDropdown";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IFilterBlackListMast } from "./Filter";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { safeFormatDate } from "../../models/DateFormatMapper";

export interface IBlackListStatusMast {
    blacklist_ID?: number,
    vendor_Company_Name?: string;
    blacklist_Status_ID?: number | null,
    vendor_Company_ID?: number | null | IClientCompanyDropdown,
    blacklist_Status?: string | null,
    blackList_Date?:Date | null,
    status_Period?:boolean | null,
    updated_By?:number | null,
    updated_At?:Date | null,
    createdBy?:number | null,
    createdAt?:Date | null,
    reason?:string | null,
    client_company?:IClientCompanyDropdown,
    blacklisted_Status?:IStatusDropdown,
    blackList_Status_ID?:number | null,

};


interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyBlackListStatus = {
    vendor_Company_Name: "",
    status_Name: "",
    blackList_Status_ID: null,
    vendor_Company_ID: null,
    blackList_Date: null,
    status_Period: null,
    reason: "",

}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBlackListStatusMast>, loading: boolean });
    const dt = useRef<any>(null);
    const [filters, setFilters] = useState<IFilterBlackListMast>(EmptyFilter);
    const leftToolbarTemplate = () => {
        return (
            <div className="my-2">
                {props.permissions.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
            </div>
        );
    };

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">BlackList Table</h5>
        </div>
    );

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyBlackListStatus });
    };
    const openEdit = (rowData: IBlackListStatusMast) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }
    const RemoveBlacklistedCompany = async (rowData: IBlackListStatusMast) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("BlackList_Mast", "DELETE", null, `Blacklist_ID=${rowData.blacklist_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "  Removed", life: 3000 });
            loadTableData();

        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }
    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to delete this from blacklisted Company `,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveBlacklistedCompany(rowData),
            reject: () => rejectFunc()
        });
    }
    const action = (rowData: any) => {
        return (
            <div className="flex gap-3">
                {props.permissions.is_Update && <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>}
                {(_roles.includes(1)) &&<Button className="pi pi-trash  bg-white border-none" style={{ fontSize: '2 rem', backgroundColor: 'white', borderColor: 'red', color: 'red' }} onClick={() => { confirmDelete(rowData) }}  ></Button>}

            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let FilterBackend: any = {

            company_ID: undefined,
            vendor_Company_ID: filters.company?.vendor_Company_ID,
            blacklist_Status_ID: filters.blacklist_Status_ID

        };
        const response = await Fetch("BlackList_Mast", "GET", null, `filter=${JSON.stringify(FilterBackend)}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const pDate = (rowData: any) => {
        let date;
        if (rowData.blackList_Date) date = format(new Date(rowData.blackList_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const cDate = (rowData: any) => {
        let date;
        if (rowData.createdAt) date = format(new Date(rowData.createdAt), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toggleVal = async (blacklist_ID?: number) => {
        const response = await Fetch("BlackList_Mast/togglestatus", "PUT", null, `Blacklist_ID=${blacklist_ID}`, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };
    const BlackListStatusStatus = (rowData: IBlackListStatusMast) => {
        return (
            <span style={{ color: rowData.blackList_Status_ID==1 ? 'blue' : '' }} className="cursor-pointer underline" onClick={() => {  toggleVal(rowData.blacklist_ID) }}>{rowData.blacklist_Status}</span>
        );

    };
    useEffect(() => {
        loadTableData();
    }, [props.reload, filters]);

    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterBlackListMast) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="vendor_Company_Name" header="Company Name" />
                {/* <Column field="blackList_Date" header="BlackList Date" body={pDate} /> */}
                <Column field="blackList_Date" header="BlackList Date" body={(rowData: any) => safeFormatDate(rowData.blackList_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="status_Period" header="Status Period" body={(rowData) => <p>{rowData.status_Period ? "Forever" : ""}</p>} />
                <Column field="user_Name" header="Created By" />
                {/* <Column field="createdAt" header="Created At" body={cDate} /> */}
                <Column field="createdAt"  header="Created At"  sortable  body={(rowData: any) => safeFormatDate( rowData.createdAt, "yyyy-MM-dd",  DateFormat )} />        
                <Column field="blacklist_Status" header="Status Name" body={BlackListStatusStatus}  />
                {props.permissions.is_Update && <Column field="" header="Action" body={action} />}
            </DataTable>
            <ConfirmDialog />

        </>
    );
}